
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";

const inventory = namespace("inventory");
const store = namespace("store");

@Component({})
export default class InventoryCheckPrint extends Vue {
  @inventory.Action queryInventoryCheckDetail;
  @store.State storeData;
  @Prop({ default: false, type: Boolean })
  visible: boolean;
  @Prop({ default: () => ({}), type: Object })
  propCheckData: any;
  @Prop({ default: "", type: String })
  inventoryCheckCode: string;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  created() {
    this.init();
  }
  checkData: any = { partsParams: [] };
  init() {
    if (this.inventoryCheckCode) {
      this.queryCheckDetail();
    } else {
      this.checkData = this.formatCheckData(this.propCheckData);
    }
  }
  queryCheckDetail() {
    this.queryInventoryCheckDetail({
      stocktakingCode: this.inventoryCheckCode
    }).then(data => {
      this.checkData = this.formatCheckData(data.data);
    });
  }
  formatCheckData(checkData) {
    checkData.partsParams = checkData?.partsParams || [];
    checkData.partsParams.map(item => {
      item.inventoryActualQtyShow = checkData.stocktakingStatus === 1 ? "" : emptyToLine(item.inventoryActualQty);
    });
    return checkData;
  }
  @Watch("inventoryCheckCode", { immediate: true })
  inventoryCheckCodeChange(val) {
    this.checkData = { partsParams: [] };
    val && this.queryCheckDetail();
  }
  @Watch("visible")
  visibleChange(val) {
    val && this.init();
  }
  handleClose() {
    this.$emit("update:visible", false);
  }
  settlementPrintObj: any = {
    id: "inventory-check-print-wraper",
    popTitle: t("v216_6.inventory-sheet"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  diffAddSymbol(num) {
    num = Number(num);
    return num > 0 ? "+" + num : num;
  }
}
